module.exports = __webpack_public_path__ + "img/1.f0aaefd1.png";